import api from './axios';

/* ══════════════════════════════════════════════════════════════
   VOCABULARY
══════════════════════════════════════════════════════════════ */

/* ── Get all vocabulary ─────────────────────────────────────────
   GET /api/vocabulary
   params: { level, type, search, page, limit }
   returns: { success, total, page, pages, data: [] }
─────────────────────────────────────────────────────────────── */
export const getVocabulary = async (params = {}) => {
  const { data } = await api.get('/vocabulary', { params });
  return data;
};

/* ── Get single word ────────────────────────────────────────────
   GET /api/vocabulary/:id
─────────────────────────────────────────────────────────────── */
export const getVocabById = async (id) => {
  const { data } = await api.get(`/vocabulary/${id}`);
  return data;
};

/* ── Get SRS due cards for today ────────────────────────────────
   GET /api/vocabulary/due
   params: { level, limit }
   🔒 Requires user token
─────────────────────────────────────────────────────────────── */
export const getDueVocab = async (params = {}) => {
  const { data } = await api.get('/vocabulary/due', { params });
  return data;
};

export const getVocabularyProgress = async () => {
  const { data } = await api.get('/vocabulary/progress');
  return data;
};

export const getVocabularySession = async (params = {}) => {
  const { data } = await api.get('/vocabulary/session', { params });
  return data;
};

export const updateVocabularyMastery = async (body) => {
  const { data } = await api.patch('/vocabulary/progress', body);
  return data;
};


/* ══════════════════════════════════════════════════════════════
   KANA
══════════════════════════════════════════════════════════════ */

export const getKana = async (params = {}) => {
  const { data } = await api.get('/kana', { params });
  return data;
};

export const getKanaProgress = async () => {
  const { data } = await api.get('/kana/progress');
  return data;
};

export const getKanaSession = async (params = {}) => {
  const { data } = await api.get('/kana/session', { params });
  return data;
};

export const updateKanaProgress = async (body) => {
  const { data } = await api.patch('/kana/progress', body);
  return data;
};


/* ══════════════════════════════════════════════════════════════
   KANJI
══════════════════════════════════════════════════════════════ */

/* ── Get all kanji ──────────────────────────────────────────────
   GET /api/kanji
   params: { level, search, page, limit }
   returns: { success, total, page, pages, data: [] }
─────────────────────────────────────────────────────────────── */
export const getKanji = async (params = {}) => {
  const { data } = await api.get('/kanji', { params });
  return data;
};

/* ── Get single kanji ───────────────────────────────────────────
   GET /api/kanji/:id
─────────────────────────────────────────────────────────────── */
export const getKanjiById = async (id) => {
  const { data } = await api.get(`/kanji/${id}`);
  return data;
};

export const getKanjiProgress = async () => {
  const { data } = await api.get('/kanji/progress');
  return data;
};

export const getKanjiSession = async (params = {}) => {
  const { data } = await api.get('/kanji/session', { params });
  return data;
};

export const updateKanjiProgress = async (body) => {
  const { data } = await api.patch('/kanji/progress', body);
  return data;
};


/* ══════════════════════════════════════════════════════════════
   GRAMMAR
══════════════════════════════════════════════════════════════ */

/* ── Get all grammar rules ──────────────────────────────────────
   GET /api/grammar
   params: { level, search, page, limit }
   returns: { success, total, page, pages, data: [] }
─────────────────────────────────────────────────────────────── */
export const getGrammar = async (params = {}) => {
  const { data } = await api.get('/grammar', { params });
  return data;
};
